var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(0 0.25)",
    fill: "#1F1F26"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 0.25,
    width: 24,
    height: 24,
    rx: 4,
    fill: "#303030"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 12.25C6 9.85324 6 8.65486 6.57113 7.7917C6.82616 7.40626 7.15626 7.07616 7.5417 6.82113C8.40486 6.25 9.60324 6.25 12 6.25C14.3968 6.25 15.5951 6.25 16.4583 6.82113C16.8437 7.07616 17.1738 7.40626 17.4289 7.7917C18 8.65486 18 9.85324 18 12.25C18 14.6468 18 15.8451 17.4289 16.7083C17.1738 17.0937 16.8437 17.4238 16.4583 17.6789C15.5951 18.25 14.3968 18.25 12 18.25C9.60324 18.25 8.40486 18.25 7.5417 17.6789C7.15626 17.4238 6.82616 17.0937 6.57113 16.7083C6 15.8451 6 14.6468 6 12.25ZM15.1062 12.2502C15.1062 13.9657 13.7154 15.3564 11.9999 15.3564C10.2843 15.3564 8.89362 13.9657 8.89362 12.2502C8.89362 10.5346 10.2843 9.14388 11.9999 9.14388C13.7154 9.14388 15.1062 10.5346 15.1062 12.2502ZM11.9999 14.3055C13.135 14.3055 14.0552 13.3853 14.0552 12.2502C14.0552 11.115 13.135 10.1948 11.9999 10.1948C10.8648 10.1948 9.94456 11.115 9.94456 12.2502C9.94456 13.3853 10.8648 14.3055 11.9999 14.3055ZM15.2288 9.7177C15.632 9.7177 15.9587 9.39092 15.9587 8.98782C15.9587 8.58471 15.632 8.25793 15.2288 8.25793C14.8257 8.25793 14.499 8.58471 14.499 8.98782C14.499 9.39092 14.8257 9.7177 15.2288 9.7177Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.7ff505ee696b6f6ba17522ff83b6cdca.svg";
export { ForwardRef as ReactComponent };